import React from 'react';
import PropTypes from 'prop-types';
// import { colors } from '../../../css';

function SupplierFeatureOne(props) {
  const { height, width, iconColor, backgroundColor } = props;

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 450"
      height={height}
      width={width}
    >
      <ellipse id="Oval-2" fill={iconColor} opacity="0.4" cx="211.7" cy="365.48" rx="56.66" ry="56.77" />
      <ellipse id="Oval-2-Copy" fill={iconColor} opacity="0.4" cx="211.92" cy="185.16" rx="56.66" ry="56.77" />
      <path
        fill={backgroundColor}
        stroke={backgroundColor}
        strokeMiterlimit="10"
        strokeWidth="0.6px"
        d="M213.22,393.9h-3v-4.52a19,19,0,0,1-6.68-1.61,16.83,16.83,0,0,1-5.72-4.24l-.51-.59,2.24-2,.52.58a15,15,0,0,0,5.06,3.69,16.45,16.45,0,0,0,5.09,1.36V366.37a44.16,44.16,0,0,1-4.29-1.66,15.49,15.49,0,0,1-3.94-2.49,10.29,10.29,0,0,1-2.62-3.55,12,12,0,0,1-.92-4.92,11.67,11.67,0,0,1,.95-4.77,11,11,0,0,1,2.64-3.7A13.25,13.25,0,0,1,206,342.8a17,17,0,0,1,4.23-1.11v-4.63h3v4.49a20,20,0,0,1,6.29,1.21,12.67,12.67,0,0,1,5.56,4l.47.58-2.25,2-.52-.64a10.92,10.92,0,0,0-4.29-3.21,14.68,14.68,0,0,0-5.26-1.15v19.95q2.44.81,4.55,1.67a17.55,17.55,0,0,1,4.24,2.41,10.92,10.92,0,0,1,3,3.53h0a10.85,10.85,0,0,1,1.09,5,12.53,12.53,0,0,1-1,5.19,11.22,11.22,0,0,1-2.92,3.9,13.35,13.35,0,0,1-4.34,2.45,19,19,0,0,1-4.54.94Zm0-26.64V386.6a13.25,13.25,0,0,0,3.35-.73,11.2,11.2,0,0,0,3.41-1.95,8.47,8.47,0,0,0,2.28-3,9.51,9.51,0,0,0,.84-4.08,7.51,7.51,0,0,0-.87-3.77,8.87,8.87,0,0,0-2.38-2.7,14.27,14.27,0,0,0-3.49-1.94C215.32,368,214.27,367.62,213.22,367.26Zm-3-22.71a12.31,12.31,0,0,0-2.79.78,10.92,10.92,0,0,0-3.08,1.88,9,9,0,0,0-2.14,2.81,8.59,8.59,0,0,0-.8,3.79,8.16,8.16,0,0,0,.79,3.8,9.07,9.07,0,0,0,2.14,2.7,12.88,12.88,0,0,0,3.11,1.92c.89.4,1.82.76,2.77,1.09Z"
      />
      <path
        fill={backgroundColor}
        d="M645,57.31,616.85,21.4l-37,31.9,2.2,2.34,32.43-28c-8.94,71.75-33.29,134-72.43,185.1-31.91,41.66-73.67,76-124.13,102.2-86,44.59-168.57,49.86-169.39,49.9V368c.83,0,84.2-5.33,170.84-50.22,50.91-26.38,93.06-61.06,125.28-103.1,39.56-51.6,64.14-114.47,73.12-186.9L642.33,59.2Z"
      />
      <g id="Group-5">
        <path
          id="Stroke-1"
          fill="none"
          strokeWidth="3.6px"
          stroke={backgroundColor}
          d="M225.8,174.12a13.38,13.38,0,1,1-13.38-13.4A13.39,13.39,0,0,1,225.8,174.12Z"
        />
        <path
          id="Stroke-3"
          fill="none"
          strokeWidth="3.6px"
          stroke={backgroundColor}
          d="M188,209.61s23.61-33.12,48.79,0"
        />
      </g>
      <rect fill={backgroundColor} x="248.42" y="183.59" width="396.11" height="3.15" />
    </svg>
  );
}

SupplierFeatureOne.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string
};

SupplierFeatureOne.defaultProps = {
  width: 800,
  height: 450,
  iconColor: '#52b7b0',
  backgroundColor: '#333232'
};

export default SupplierFeatureOne;
